import { render, staticRenderFns } from "./ListReturMarketplace.vue?vue&type=template&id=054728ed&"
import script from "./ListReturMarketplace.vue?vue&type=script&lang=js&"
export * from "./ListReturMarketplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports